<template>
	<div
		:class="[
			withoutMargin ? 'mb-5 md:mb-0' : 'mb-5 md:mb-10',
			'break-inside-avoid-column group relative border border-dj-grey-light/50 rounded-big bg-white',
		]"
	>
		<slot></slot>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
	name: "DjBox",
	props: {
		withoutMargin: {
			type: Boolean,
			default: false,
		},
	},
});
</script>
